import { Timestamp } from "firebase/firestore";
import { ProductDb } from "../database/models/ProductDb";

export class Product {
    guid: string;
    name: string;
    companyGuid: string;
    emailTemplate: string | null;

    createdDate: Date;
    lastModifiedDate: Date;
    deletedDate: Date | null;

    constructor(guid: string, name: string, companyGuid: string, emailTemplate: string | null, createdDate: Date, lastModifiedDate: Date, deletedDate: Date | null) {
        this.guid = guid;
        this.name = name;
        this.companyGuid = companyGuid;
        this.emailTemplate = emailTemplate;

        this.createdDate = createdDate;
        this.lastModifiedDate = lastModifiedDate;
        this.deletedDate = deletedDate;
    }
}

export function ProductToDbMapper(model: Product) {
    const mapped: ProductDb = {
        guid: model.guid,
        name: model.name,
        companyGuid: model.companyGuid,
        emailTemplate: model.emailTemplate,

        createdDate: model.createdDate,
        deletedDate: model.deletedDate,
        lastModifiedDate: model.lastModifiedDate,
    };
    return mapped;
}

export function ProductFromDbMapper(db: ProductDb) {
    const mapped: Product = new Product(
        db.guid,
        db.name,
        db.companyGuid,
        db.emailTemplate,
        db.createdDate,
        db.lastModifiedDate,
        db.deletedDate,);
    return mapped;
}